// --------------------This is the table for MEMBER MAPPING LIST SHOS INSIDE SESSION DROPDOWN -----------------------------------
import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
import AddMember from './AddMember';
import AddNewMember from './AddNewMember';
import { DeleteMemberMapping, EditMember, EditMemberMemberMappingRow, FiteMMTableAdmin, GetConstituency, GetConstituencyMaped, GetKlaListForSearchFilter, GetRole, GetSalutation, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla, MembersListApi, getMemberListInTable } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
// import Select from "react-select";
import DeleteModal from '../DeleteModal';
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import Select, { components } from 'react-select';
import { useNavigate } from 'react-router-dom';
import AdminPagination from '../../Components/AdminPagination';
import { toast, ToastContainer } from 'react-toastify';

const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;

    if (data.value === 'addnewkla' || data.value === 'addnewsession') {
        return (
            <div
            className='hover:bg-green-500 hover:text-white text-green-500'
                ref={innerRef}
                {...innerProps}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    // backgroundColor: 'lightyellow',
                    padding: '10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                <span className='font-bold' >{data.label}</span>
                <Icon icon="basil:add-outline" className='ms-1 font-bold' />

            </div>
        );
    }

    return <components.Option {...props} />;
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable


};
const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function TableMember() {
    const { addMember, setaddMember } = useContext(addcontext)
    const {paginationStartIndexAD,setPaginationStartIndexAD}=useContext(addcontext)
    const {paginationEndIndexAD,setPaginationEndIndexAD}=useContext(addcontext)
    const [membersList, setMembersList] = useState([])
    const baseUrl = process.env.REACT_APP_BASEURL
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setImagePreview('')
    }
    const [klaList, setKlaList] = useState([])
    const [klaoptions, setKlaOptions] = useState([]);
    const [token, setToken] = useState()
    const [isMM, setIsMM] = useState(false)

    const [idToDelete, setidToDelete] = useState()
    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
    }
    const [roleList, setRoleList] = useState([])
    const [constituencyList, setconstituencyList] = useState([])
    const [saluationtList, setSaluationtList] = useState([])

    const [selectedOptionKla, setSelectedOptionKla] = useState(null);
    const [selectedOptionsession, setSelectedOptionsession] = useState(null);
    const [klaListF, setKlaListF] = useState([]);
    const [sessionListF, setSessionListF] = useState([]);
    const [totalmemberCount,setTotalmemberCount]=useState()
    const [errorMsg, setErrorMsg] = useState()
    const navigate=useNavigate()
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,


        },
        {
            name: 'Mapping Id',
            selector: row => row.id,
            sortable: true,


        },
        
        {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
        {
            name: 'Photo',
            selector: row => row.photo,
            // sortable: true,


        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,


        },
        {
            name: 'Role',
            selector: row => row.Role,
            sortable: true,
        },
        {
            name: 'Designation',
            selector: row => row.designation,
            sortable: true,
        },
        {
            name: 'Constituency',
            selector: row => row.constituency,
            sortable: true,
        },
        {
            name: 'Salutation',
            selector: row => row.Salutation,
            sortable: true,
        },
        {
            name: 'KLA',
            selector: row => row.kla,
            sortable: true,
        },
        {
            name: 'Session',
            selector: row => row.session,
            sortable: true,
        },
        {
            name: 'Elected Date',
            selector: row => row.electeddate,
            sortable: true,
        },
        {
            name: 'End Date',
            selector: row => row.endtdate,
            sortable: true,
        },
        {
            name: 'Reservation',
            selector: row => row.reserved,
            sortable: true,
        },

        {
            name: 'Uploader',
            selector: row => row.uploader,
            sortable: true,
        },
        {
            name: 'Created at',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated at',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Delete',
            selector: row => row.active,
            sortable: true,
        },
       
        

    ];
    useEffect(() => {
        setToken(sessionStorage.getItem('access_token'))
        if (token) {
            MembersList()
        }
        else {
            console.log('token fetching failed');
        }
    }, [token, isEdited,paginationStartIndexAD,paginationEndIndexAD])
    const MembersList = async () => {
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await getMemberListInTable(reqHeader,paginationStartIndexAD,paginationEndIndexAD)
        setMembersList(result?.data?.data)
        setTotalmemberCount(result?.data?.count)
        setErrorMsg(result?.response?.data?.message)
        console.log(result);
    }
    var data = []
    membersList && membersList?.map((item, index) => {
        const slno = index + 1
        const id = item.id
        const photo = <img src={`${baseUrl}${item.member_image}`} className='h-20 w-20 p-2 rounded' />
        const name = item.member_name;
        const Role = item.role;
        const designation = item.designation;
        const constituency = item.constituency;
        const Salutation = item.salutation
        const kla = item.kla
        const session = item.session
        const electeddate = item.member_start_date;
        const endtdate = item.member_end_date;
        const reserved = item.reserved_for
        const uploader = item.uploaded_by
        const createdAt = item.created_at?.slice(0, 10)
        const updatedAt = item.updated_at?.slice(0, 10)
        const Action = <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit</a>;
        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>

        const newObj = { slno, id, photo, name, Role, constituency, Salutation, session, electeddate, endtdate, active, reserved, uploader, createdAt, updatedAt, Action, designation,kla };
        data.push(newObj);
    })
    const [imagePreview, setImagePreview] = useState('');

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const newFormData = { ...dataToEdit }; // Create a copy of the dataToEdit object
            newFormData.member_image = file; // Update the member_image property with the new file
            setDataToEdit(newFormData); // Update the state with the new object
            console.log(newFormData);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };


    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()
        if(item?.session_id){
            ConstutencyListApi(item?.session_id)
        }

    }

    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Authorization": `${token}`
        };
        // Make the API call with data and headers
        const dataToEditApi = {
            member_name: dataToEdit?.member_name,
            session: dataToEdit?.session,
            role: dataToEdit?.role?.label??dataToEdit?.role,
            constituency: dataToEdit?.constituency?.label??dataToEdit?.constituency,
            salutation: dataToEdit?.salutation?.label??dataToEdit?.salutation,
            designation: dataToEdit?.designation,
            mal_designation:dataToEdit?.mal_designation,
            reserved_for: dataToEdit?.reserved_for,
            mal_reserved_for:dataToEdit?.mal_reserved_for
        }
        try {
            // console.log();
            const result = await EditMemberMemberMappingRow(dataToEditApi, reqHeader, dataToEdit.id)
            if(result.status==200){
                handleClose();
                setIsEdited(isEdited + 1);
                toast.success("Editing successfull")
            }else{
                toast.error(result?.response?.data?.message??"There was a problem editing!!")
            }
            // const data = await result.json();
            // console.log(result);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteMemberMapping(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }

    // ------------------------------------------FILTER IN VIDEO----------------------------------------------
    // Fetch KLA List for filter
    const klaListCallApiFilter = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaListF(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApiFilter();
    }, []);

    const klaoptionsF = klaListF.map((item) => ({
        value: item.kla_id,
        label: `KLA${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApiFilter = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionListF(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApiFilter();
    }, [selectedOptionKla]);

    const sessionoptionsF = sessionListF.map((item) => ({
        value: item.session_id,
        label: `Session${item.session_no}`,
    }));

    const handlechange = (option) => {
        if(option?.value=='addnewkla'){
            navigate('/octobersky/kla')
        }
        else{
        setSelectedOptionKla(option)
        }}
    const handlechangesession = (option) =>{
        if(option?.value=='addnewsession'){
            navigate('/octobersky/session')
        }
        else{
            setSelectedOptionsession(option);
        }
        }
    const FilterAdminVideoTable = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        // const member_id = selectedOptionMember?.value;
        // const event_id = selectedOptionEvent?.value;
        // const constituency_id = selectedOptionconstituency?.value;

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        // if (member_id) obj.member_id = member_id;
        // if (event_id) obj.event_id = event_id;
        // if (constituency_id) obj.constituency_id = constituency_id;

        try {
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const result = await FiteMMTableAdmin(obj, reqHeader);
            console.log(result);
            setMembersList(result?.data?.data || []);
            setErrorMsg(result?.response?.data?.message)
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession) {
            FilterAdminVideoTable();
        }
    }, [selectedOptionKla, selectedOptionsession]);

    // ------------------------------------------FILTER IN VIDEO END----------------------------------------------

    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        MembersList()

    }

    // get role list
    const RoleListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultrole = await GetRole();
            // console.log(resultrole);
            setRoleList(resultrole?.data?.data)
        } catch (error) {
            console.error("Error fetching role list :", error);
        }
    }


    useEffect(() => {
        RoleListApi();
    }, []);

    // salutation dropdown
    const roleoptions = roleList?.map((item, index) => ({
        value: item.role_id,
        label: `${item.role_name}`,
        valuefrosearch: item.role_id

    }));

    // get Constituency list
    const ConstutencyListApi = async (id) => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultConstituency = await GetConstituencyMaped(id);
            // console.log(resultConstituency);
            setconstituencyList(resultConstituency?.data?.data)
        } catch (error) {
            console.error("Error fetching constituency list :", error);
        }
    }


    // useEffect(() => {
    //     ConstutencyListApi();
    // }, []);

    // constituency dropdown
    const constituencyOptions = constituencyList?.map((item, index) => ({
        value: item.constituency_id,
        label: `${item.constituency_name}`,
        valuefrosearch: item.constituency_id

    }));

    // get salutation list
    const SalutationListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultsalute = await GetSalutation();
            // console.log(resultsalute);
            setSaluationtList(resultsalute?.data?.data)
        } catch (error) {
            console.error("Error fetching salutation list :", error);
        }
    }


    useEffect(() => {
        SalutationListApi();
    }, []);

    // salutation dropdown
    const saluteoptions = saluationtList?.map((item, index) => ({
        value: item.id,
        label: `${item.salutation_name}`,
        valuefrosearch: item.id

    }));


    return (
        <>
            {/* {addMember ? ( */}
            {/* <AddNewMember /> */}
            {/* ) : ( */}
            <>

                <div className='flex flex-row justify-center gap-5'>
                    <div className='flex flex-row w-3/12  text-blue-400'>

                        <Select
                            placeholder='KLA'
                            className='w-full'
                            options={[ ...klaoptionsF,{ value: 'addnewkla', label: 'Add new kla' }]}
                            value={selectedOptionKla}
                            onChange={handlechange}
                            components={{ Option: CustomOption }}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderRadius: '0.5rem',
                                }),
                            }}
                        />
                    </div>

                    <div className='flex flex-row w-3/12 text-blue-400'>
                        <Select
                            placeholder='Session'
                            className='w-full'
                            options={[ ...sessionoptionsF,{ value: 'addnewsession', label: 'Add new session' }]}
                            value={selectedOptionsession}
                            onChange={handlechangesession}
                            components={{ Option: CustomOption }}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderRadius: '0.5rem',
                                }),
                            }}
                        />
                    </div>

                    <div className='flex flex-col '>
                        <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded-lg w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                            <span>Clear Filter</span>
                            <Icon icon="bx:reset" />
                        </button>
                    </div>

                </div>
                <>
                {membersList?.length>0?
                <div className='flex flex-col gap-1'>
                <DataTable
                    title={<div className='flex flex-row items-center'><span className='me-2'>Member Mapping List</span> <PopOver dataToDisplay={'Map Member to a session in Manage Session. Constituency, Role, etc in Manage Session > Add New Session'} /></div>}
                    columns={columns}
                    data={data}
                    customStyles={customStyles}
                    // pagination
                    dense
                    highlightOnHover
                    selectableRowsHighlight
                    paginationPerPage={50} // Initial page size
                    paginationRowsPerPageOptions={[50, 100, 200, 500]} // Options for users to change page size

                // selectableRows
                // progressPending
                // progressComponent={<h1>load</h1>}
                />
                {totalmemberCount>25&&<AdminPagination count={totalmemberCount}/>}
                </div>

:
        <>
        {!errorMsg?<div className="flex justify-center items-center w-full h-full flex-col gap-5">
        <SyncLoader 
          color="#3498db"
          loading={true}
          speedMultiplier={1}
        />
                <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>

      </div>
      :
      <div className="flex justify-center items-center w-full h-full flex-col gap-5">
      <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorMsg}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
      </div>
      }
      </>}
      </>

            </>
            {/* )} */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        {/* <div className='w-full items-center flex-col flex'>
                <label htmlFor="memberimage" className='w-10/12 h-40 cursor-pointer'>
                    <div className='bg-success border-dashed border-2 h-full overflow-hidden p-1 rounded border-light-blue-600 flex justify-center items-center flex-col'>
                        {imagePreview ? (
                            <img className='h-36 w-36' src={imagePreview} alt="Uploaded Preview" />
                        ) : (
                            <>
                                <img className='h-32 w-32' src={`${baseUrl}${dataToEdit?.member_image}`} alt="Upload Icon" />
                                <span className='text-blue-500 underline text-sm'>Upload new image</span>
                            </>
                        )}
                    </div>
                </label>
                <input id='memberimage' type="file" style={{ visibility: 'hidden' }} onChange={handleImageUpload} />
            </div> */}
                        <h4 className='text-center text-blue-500'>Session: {dataToEdit?.session}</h4>
                        <div className='w-10/12 flex flex-col'>
                            <label htmlFor="eventname" className='text-gray-500'>Name</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.member_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, member_name: e.target.value })}
                                type="text"
                                readOnly
                                className=' w-full h-10 rounded-lg border border-dashed border-gray-300 text-gray-500  px-2'
                            />
                        </div>


                        {/* <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Role</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.role}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, role: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div> */}

                        <div className='flex flex-col w-10/12 mt-5'>
                            <label>Role</label>
                            <Select
                                placeholder={dataToEdit?.role}
                                options={roleoptions}
                                value={dataToEdit?.role}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, role: e })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='flex flex-col w-10/12 mt-5'>
                            <label>Constituency</label>
                            <Select
                                placeholder={dataToEdit?.constituency}
                                options={constituencyOptions}
                                value={dataToEdit?.constituency}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, constituency: e })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='flex flex-col w-10/12 mt-5'>
                            <label>Salutation</label>
                            <Select
                                placeholder={dataToEdit?.salutation}
                                options={saluteoptions}
                                value={dataToEdit?.salutation}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, salutation: e })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Designation</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.designation}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, designation: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Designation malayalam</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.mal_designation}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, mal_designation: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        {/* <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Reservation flag</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.reserved_for}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, reserved_for: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Reservation malayalam</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.mal_reserved_for}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, mal_reserved_for: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div> */}

                        <div className='flex flex-row justify-center mt-5'>
                            <button className='px-6 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-6 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>


            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>

            <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />
        </>
    )
}

export default TableMember